module.exports = __webpack_public_path__ + "img/card1.2a90a8a6.png";